import { WalletOutlined } from '@ant-design/icons';
import React from 'react';
import { Datatype } from '../../../../expressions/datatype/Datatype';
import { getSimpleWidgetReference } from '../../../../expressions/references/builder/getSimpleWidgetReference';
import { RequiredRule } from '../../../../rules/repository';
import { tran } from '../../../../translations/schema/TranslationSchema';
import { IWidgetType } from '../../../IWidgetType';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget';
import { IPaymentRowWidget } from './IPaymentRowWidget';
import { PaymentRowConfigComponent } from './PaymentRowConfigComponent';
import { PaymentRowConfigSchema } from './PaymentRowConfigSchema';
import { PaymentRowWidgetComponent } from './PaymentRowWidgetComponent';
import { PaymentRowWidgetPreviewComponent } from './PaymentRowWidgetPreviewComponent';
import { createPaymentRowFormSchema } from './createPaymentRowFormSchema';
import { getPaymentRowReferences } from './getPaymentRowReferences';

export const PaymentRowWidgetType: IWidgetType<IPaymentRowWidget> = {
  type: WidgetType.PaymentRow,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Advanced,
  name: 'Voce di Costo',
  icon: <WalletOutlined />,
  hasValue: true,

  formComponent: PaymentRowWidgetComponent,
  createFormSchema: createPaymentRowFormSchema,

  configComponent: PaymentRowConfigComponent,
  configValidator: PaymentRowConfigSchema,

  previewComponent: PaymentRowWidgetPreviewComponent,

  translationSchema: tran.widget({}),
  configOptions: {
    removeCollapsePanel: true,
  },

  rules: [RequiredRule],
  getReference: getSimpleWidgetReference(Datatype.Number),
  getSiblingReferences: getPaymentRowReferences,
  alwaysEnabled: true,
};
